module.exports = __webpack_public_path__ + "img/logo-ylyx.583b29d5.png";